import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="age-by-birthdate"
export default class extends Controller {
  static targets = ["birthdate", "age", "ageDisplay"]

  connect() {
    this.update()
  }

  update() {
    if (!this.hasBirthdateTarget || !this.hasAgeTarget || !this.hasAgeDisplayTarget) return

    const birthdate = this.parseDate(this.birthdateTarget.value)
    if (!birthdate) {
      this.clearAgeFields()
      return
    }

    const today = new Date()
    today.setHours(0, 0, 0, 0)

    if (birthdate > today) {
      this.clearAgeFields()
      return
    }

    const years = this.fullYearsDifference(birthdate, today)
    if (years >= 1) {
      this.ageTarget.value = String(years)
      this.ageDisplayTarget.value = this.ageLabel(years, "año", "años")
      return
    }

    const months = this.fullMonthsDifference(birthdate, today)
    const safeMonths = Math.max(months, 0)
    this.ageTarget.value = String(safeMonths)
    this.ageDisplayTarget.value = this.ageLabel(safeMonths, "mes", "meses")
  }

  clearAgeFields() {
    this.ageTarget.value = ""
    this.ageDisplayTarget.value = ""
  }

  ageLabel(value, singular, plural) {
    return `${value} ${value === 1 ? singular : plural}`
  }

  parseDate(value) {
    if (!value) return null

    const parts = value.split("-")
    if (parts.length !== 3) return null

    const year = Number(parts[0])
    const month = Number(parts[1])
    const day = Number(parts[2])

    if (!Number.isInteger(year) || !Number.isInteger(month) || !Number.isInteger(day)) return null

    const date = new Date(year, month - 1, day)
    date.setHours(0, 0, 0, 0)

    if (
      date.getFullYear() !== year ||
      date.getMonth() !== month - 1 ||
      date.getDate() !== day
    ) {
      return null
    }

    return date
  }

  fullYearsDifference(fromDate, toDate) {
    let years = toDate.getFullYear() - fromDate.getFullYear()

    const hasNotHadBirthdayYet =
      toDate.getMonth() < fromDate.getMonth() ||
      (toDate.getMonth() === fromDate.getMonth() && toDate.getDate() < fromDate.getDate())

    if (hasNotHadBirthdayYet) years -= 1

    return years
  }

  fullMonthsDifference(fromDate, toDate) {
    let months = (toDate.getFullYear() - fromDate.getFullYear()) * 12
    months += toDate.getMonth() - fromDate.getMonth()

    if (toDate.getDate() < fromDate.getDate()) months -= 1

    return months
  }
}
